import React, { useState, useEffect } from "react";
import SideNavigation from "../SideNavigation";
import NavigationBar from "../NavigationBar";
import "../../styles/Dashboard.scss"
import {Button, Modal, OverlayTrigger, Spinner, Table, Tooltip, CardColumns, Form, Alert} from "react-bootstrap";
import AddWidget from "../dashboard/AddWidget";
import micro_reporter_api from "../../apis/micro-reporter-api";
import DashboardChart from "../dashboard/DashboardChart";
import QueryForm from "../report/QueryForm";
import Utils from "../../libraries/utils";
import { useKeycloak } from '@react-keycloak/web'

const Dashboard = () => {

  const { keycloak } = useKeycloak();

  const [modalShow,setModalShow] = useState();
  const [widgetList,setWidgetList] = useState([]);
  const [dashboardList,setDashboardList] = useState([]);
  const [isDashboardChart,setIsDashboardChart] = useState(false);
  const [isChangeWidgetItem,setIsChangeWidgetItem] = useState(false);

  useEffect(() => {
    getAddWidgetList();
    getDashboardList();

	},[isChangeWidgetItem]);

  const widgetClick = () =>{
    setModalShow(true);
  };

  const getAddWidgetList = () => {
    (async () => {
      try{
          Utils.loadingScreen("show");
          let user = JSON.parse(localStorage.getItem("user"));
          await micro_reporter_api.get(`/micro-reporter/dashboard/get-dashboard-details?userId=` + user.id).then((response) => {
          setWidgetList(response.data);
          Utils.loadingScreen("hide");
				})
      }catch (err){
          Utils.loadingScreen("hide");
      }
  })();

	};

  const getDashboardList = () => {
    (async () => {
      try{
        Utils.loadingScreen("show");
        let user = JSON.parse(localStorage.getItem("user"));
        await micro_reporter_api.get(`/micro-reporter/dashboard/by-user-id?userId=` + user.id).then((response) => {
          setDashboardList(response.data);
          setIsDashboardChart(true);
          Utils.loadingScreen("hide");
				})
      }catch (err){
          Utils.loadingScreen("hide");
      }
  })();
  }

  return(
    <React.Fragment>
      <SideNavigation current="dashboard"/>
      <div className="page-order">
        <NavigationBar/>
      </div>
      <div className="dashboard-wrapper">
        <div className="dashboard-title">
          <h5 className="page-title">Dashboard</h5>
          <Button variant="primary" id="widget-add-button" className="btn btn-primary" onClick={()=>widgetClick()}>
            <a className="link">
              Widgets
            </a>
          </Button>
        </div>


        {/*<div>{`User is ${*/}
        {/*  !keycloak.authenticated ? 'NOT ' : ''*/}
        {/*}authenticated`}</div>*/}



        {/*{!!keycloak.authenticated && (*/}
        {/*  <button type="button" onClick={() => keycloak.logout()}>*/}
        {/*    Logout*/}
        {/*  </button>*/}
        {/*)}*/}

        {/*{!keycloak.authenticated && (*/}
        {/*  <button type="button" onClick={() => keycloak.login()}>*/}
        {/*    Login*/}
        {/*  </button>*/}
        {/*)}*/}


        <div className="container-fluid">
          <div className="col-12">
            <div className="row">
              <div className="col-4">
                  <Alert variant="primary">
                      <Alert.Heading>{widgetList.projectCount}</Alert.Heading>
                      <hr />
                      <p>
                          <span>{widgetList.projectCount < 2 ? 'Project' : 'Projects'}</span>
                      </p>
                  </Alert>
              </div>
                <div className="col-4">
                    <Alert variant="secondary">
                        <Alert.Heading>{widgetList.reportCount}</Alert.Heading>
                        <hr />
                        <p>
                            <span>{widgetList.reportCount < 2 ? 'Report' : 'Reports'}</span>
                        </p>
                    </Alert>
                </div>
                <div className="col-4">
                    <Alert variant="success">
                        <Alert.Heading>{widgetList.chartCount}</Alert.Heading>
                        <hr />
                        <p>
                            <span>{widgetList.chartCount < 2 ? 'Chart' : 'Charts'}</span>
                        </p>
                    </Alert>
                </div>
            </div>
          </div>

          <div className="col-12">
            <div className="row">
            {isDashboardChart ? dashboardList.chartWidgets?.map(x=>{
                return(
                  <div className="col-md-6 widget-item">
                  <DashboardChart chartWidgets={x} />
                  </div>
                )
              })  : null}

              {isDashboardChart ? dashboardList.reportWidgets?.map(x=>{
                return(
                  <div className="col-md-6 widget-item">
                    <QueryForm isWidget={true} rid={x.report.id} />
                  </div>
                )
              })  : null}
            </div>

          </div>
        </div>
      </div>
      <AddWidget
        show={modalShow}
        onHide={() => setModalShow(false)}
        json={widgetList}
        setisChangeWidgetItem={setIsChangeWidgetItem}
      />

      </React.Fragment>
  );
};

export default Dashboard;
